export const beforePreloader = ()=> {
    function firstSectionAnim() {
        if (window.matchMedia("(min-width:1024px)").matches && document.querySelector('.hero-main')) {
            if (navigator.userAgent.indexOf("Firefox") != -1) {
                document.querySelector('.site-main').style = `padding-top:${window.innerHeight + 10}px`
            } else {
                document.querySelector('.site-main').style = `padding-top:${window.innerHeight}px`
            }
        } else {
            document.querySelector('.site-main').style = '';
        }
    }
    firstSectionAnim()

    window.addEventListener('resize',firstSectionAnim)
    console.log('before')
}